/** Cucumber Size Group / Size labels from serving columns. Add variety keys here. */

const SENTINEL = new Set(['', 'n/a', 'na', 'not classified', 'none', 'null']);

function live(value) {
  if (value == null) return '';
  const s = String(value).trim();
  if (SENTINEL.has(s.toLowerCase())) return '';
  return s;
}

export function isBushelPackage(pkg) {
  return /bushel/i.test(String(pkg || ''));
}

/**
 * @param {object} row
 * @returns {{ group: string, size: string }}
 * Field bushel: group from size_group, size empty (no count).
 * Field carton / other numbered: size from size_granularity.
 */
export function sizeFields(row) {
  const group = live(row?.size_group);
  const gran = live(row?.size_granularity);
  const pkg = row?.package || row?.sku || '';
  const variety = String(row?.variety || '');
  if (/pickle/i.test(variety)) {
    const item = live(row?.item_size);
    const size = gran || (/\d/.test(item) ? item : '');
    return { group, size };
  }
  if (isBushelPackage(pkg)) return { group, size: '' };
  return { group, size: gran };
}

export function readSizeGroup(row) {
  return sizeFields(row).group || undefined;
}

export function readSize(row) {
  return sizeFields(row).size || undefined;
}

/**
 * Size Group and Size granularity: empty = blank only; any checks keep
 * those values plus blank rows (1 1/9 stays when a count is on).
 */
export function applyCucumberOptionalDimFilter(rows, selected, options, getValue) {
  const list = Array.isArray(rows) ? rows : [];
  const opts = options || [];
  const sel = Array.isArray(selected) ? selected : [];
  if (!opts.length) return list;
  if (!sel.length) return list.filter((r) => !getValue(r));
  return list.filter((r) => {
    const v = getValue(r);
    if (!v) return true;
    return sel.includes(v);
  });
}

export function cucumberOptionalDimKeepsRow(item, selected, options, getValue) {
  const opts = options || [];
  const sel = Array.isArray(selected) ? selected : [];
  if (!opts.length) return true;
  const v = getValue(item);
  if (!sel.length) return !v;
  if (!v) return true;
  return sel.includes(v);
}

export function applyCucumberSizeGranularityFilter(rows, selected, options, getSize = readSize) {
  return applyCucumberOptionalDimFilter(rows, selected, options, getSize);
}

export function cucumberSizeGranularityKeepsRow(item, selected, options, getSize = readSize) {
  return cucumberOptionalDimKeepsRow(item, selected, options, getSize);
}

export function applyCucumberSizeGroupFilter(rows, selected, options, getGroup = readSizeGroup) {
  return applyCucumberOptionalDimFilter(rows, selected, options, getGroup);
}

export function cucumberSizeGroupKeepsRow(item, selected, options, getGroup = readSizeGroup) {
  return cucumberOptionalDimKeepsRow(item, selected, options, getGroup);
}

/** Keep checks that still exist. Empty or all-dead → All (product default for size dims). */
export function keepOrAll(selected, options) {
  const sel = Array.isArray(selected) ? selected : [];
  const opts = options || [];
  if (!sel.length) return opts;
  const keep = sel.filter((s) => opts.includes(s));
  return keep.length ? keep : opts;
}

/** Crop registry API (FOB + Terminal). Next crop exports the same names. */
export const applySizeGroupFilter = applyCucumberSizeGroupFilter;
export const applySizeFilter = applyCucumberSizeGranularityFilter;
export const sizeGroupKeepsRow = cucumberSizeGroupKeepsRow;
export const sizeKeepsRow = cucumberSizeGranularityKeepsRow;
